
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";




const DataTableAssemblyComponentsWorkOrder=({listComponents})=>{



  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  function titleFormatter(cell, row) {
    return (
      <span>
        {row.assemblyComponentsWorkOrder.product.productCode}-{row.assemblyComponentsWorkOrder.product.name}
      </span>
    );
  }
  function qteDemandeFormatter(cell, row) {
    return (
      <span>
        {row.assemblyComponentsWorkOrder.quantityDemande}
      </span>
    );
  }

  function qteConsommeFormatter(cell, row) {
    return (
      <span>
        {row.assemblyComponentsWorkOrder.quantityConsomme}
      </span>
    );
  }
  function uniteFormatter(cell, row) {
    return (
      <span>
        {row.assemblyComponentsWorkOrder.unitOfMeasure.code}- {row.assemblyComponentsWorkOrder.unitOfMeasure.name}
      </span>
    );
  }
  const columns = [
    {
      dataField: "index",
      text: "Titre",
      align: "center",
      headerAlign: "center",
      formatter: titleFormatter,
    },
    {
      dataField: "index",
      text: "QTE demandée",
      align: "center",
      headerAlign: "center",
      formatter: qteDemandeFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "index",
      text: "QTE consommée",
      align: "center",
      headerAlign: "center",
      formatter: qteConsommeFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantityInStock",
      text: "QTE en stock",
      align: "center",
      headerAlign: "center",
      // formatter: qteConsommeFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "index",
      text: "Unité de mesure",
      align: "center",
      headerAlign: "center",
      formatter: uniteFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    // {
    //   dataField: "unitOfMeasure.id",
    //   text: "Unité de mesure",
    //   align: "center",
    //   headerAlign: "center",
    //   formatter: uniteFormatter,

    //   headerStyle: () => {
    //     return { width: "15%" };
    //   },
    // },
  ];


  return (
    <ToolkitProvider keyField="index" data={listComponents} columns={columns}>
      {(props) => (
        <div>
          <div className="row">
            <BootstrapTable
              {...props.baseProps}
              pagination={paginationFactory(options)}
              striped
              hover
              condensed
              // expandRow={expandRow}
            />
          </div>
        </div>
      )}
    </ToolkitProvider>
  );

}
export default DataTableAssemblyComponentsWorkOrder;